.dialog {
  top: 32px;
  transform: translateX(-50%);
  margin: 0;
}
